// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    }); 
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i];
      if (thisVideoEl.closest('media-gallery')) {
        continue;
      }
      videoHeight = thisVideoEl.clientHeight,
      videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setInterval(countDown, 1000); // Start the countdown interval
  countDown(); // Initial call to display immediately

  function countDown() {
    const countCardSections = document.querySelectorAll('.countd_all');
    countCardSections.forEach((countdownSection) => {
      const countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
      const now = Date.now();
      const distance = countDownDate - now;

      const daysElement = countdownSection.querySelector('.main_cdays .wb_cdays');
      const hoursElement = countdownSection.querySelector('.main_chours .wb_chours');
      const minutesElement = countdownSection.querySelector('.main_cminutes .wb_cminutes');
      const secondsElement = countdownSection.querySelector('.main_cseconds .wb_cseconds');

      // Use countd_all as the parent context to find the message element
      const messageElement = countdownSection.querySelector('.main_ctext');

      if (distance < 0 || isNaN(countDownDate)) {
        // Timer is over
        daysElement.textContent = "00";
        hoursElement.textContent = "00";
        minutesElement.textContent = "00";
        secondsElement.textContent = "00";

        if (messageElement && messageElement.textContent.trim() !== '') {
          // If message exists
          daysElement.parentElement.style.display = "none";
          hoursElement.parentElement.style.display = "none";
          minutesElement.parentElement.style.display = "none";
          secondsElement.parentElement.style.display = "none";
          countdownSection.style.display = "inline-block"; // Show countdown section
          messageElement.style.display = "block"; // Show message
        }
      } else {
        // Update timer values
        daysElement.textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
        hoursElement.textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutesElement.textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        secondsElement.textContent = Math.floor((distance % (1000 * 60)) / 1000);
        if (messageElement) {
          messageElement.style.display = "none"; // Hide message while counting down
        }
      }
    });
  }
});




// WLG_VARIANT_ACTION_SYNC_V2
(function(){
    if(window.__wlgVariantActionSyncV2)return;
    window.__wlgVariantActionSyncV2=true;
    function getVariantId(swatch){
      if(!swatch)return null;
      var values=[swatch.getAttribute('data-variant-id'),swatch.dataset&&swatch.dataset.variantId,swatch.value];
      for(var i=0;i<values.length;i++){if(values[i]&&/^\d+$/.test(String(values[i])))return String(values[i]);}
      var match=(swatch.id||'').match(/^swatch-collection-(\d+)-/);
      return match?match[1]:null;
    }
    function getCard(node){return node&&node.closest&&node.closest('.globo-swatch-product-item,.card-wrapper,.grid__item');}
    function getSelected(card){return card&&card.querySelector('input[type="radio"][id^="swatch-collection-"]:checked');}
    function sync(card,swatch){
      var variantId=getVariantId(swatch||getSelected(card));
      if(!card||!variantId)return;
      card.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input){
        var setter=Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set;
        setter.call(input,variantId);
        input.setAttribute('value',variantId);
        input.disabled=false;
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
      card.querySelectorAll('[data-product-url]').forEach(function(control){
        var raw=control.getAttribute('data-product-url');
        if(!raw)return;
        try{var url=new URL(raw,location.origin);url.searchParams.set('variant',variantId);control.setAttribute('data-product-url',url.pathname+url.search+url.hash);}catch(error){}
      });
      card.querySelectorAll('a[href*="/products/"]').forEach(function(link){
        try{var url=new URL(link.getAttribute('href'),location.origin);url.searchParams.set('variant',variantId);link.setAttribute('href',url.pathname+url.search+url.hash);}catch(error){}
      });
    }
    document.addEventListener('change',function(event){
      var target=event.target;
      var swatch=target&&target.closest&&target.closest('input[type="radio"][id^="swatch-collection-"]');
      if(!swatch||!swatch.checked)return;
      var card=getCard(swatch);
      sync(card,swatch);
      [0,50,150].forEach(function(delay){setTimeout(function(){sync(getCard(swatch),swatch);},delay);});
    },true);
    ['pointerdown','click'].forEach(function(type){document.addEventListener(type,function(event){
      var target=event.target;
      var action=target&&target.closest&&target.closest('[data-product-url],form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] [name="add"]');
      if(action)sync(getCard(action));
    },true);});
    document.addEventListener('submit',function(event){
      var form=event.target;
      if(form&&form.matches&&form.matches('form[action*="/cart/add"]'))sync(getCard(form));
    },true);
  })();

// WLG_QUICK_LOOK_VARIANT_SYNC_V21
(function(){
  if(window.__wlgQuickLookVariantSyncV21)return;
  window.__wlgQuickLookVariantSyncV21=true;
  function scopeFor(node){
    if(!node||!node.closest)return null;
    return node.closest('.globo-swatch-product-item')||node.closest('quick-add-modal,dialog,.quick-add-modal');
  }
  function variantId(scope){
    if(!scope)return null;
    var swatch=scope.querySelector('input[type="radio"][id^="swatch-collection-"]:checked');
    var match=swatch&&(swatch.id||'').match(/^swatch-collection-(\d+)-/);
    if(match)return match[1];
    var data=scope.querySelector('script[data-selected-variant]');
    if(data){try{var parsed=JSON.parse(data.textContent);if(parsed&&parsed.id)return String(parsed.id);}catch(error){}}
    return null;
  }
  function sync(node){
    var scope=scopeFor(node);
    var id=variantId(scope);
    if(!scope||!id)return;
    scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input){
      var setter=Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set;
      setter.call(input,id);
      input.setAttribute('value',id);
      input.disabled=false;
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  ['pointerdown','click'].forEach(function(type){document.addEventListener(type,function(event){
    var target=event.target;
    var action=target&&target.closest&&target.closest('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] [name="add"]');
    if(action)sync(action);
  },true);});
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(form&&form.matches&&form.matches('form[action*="/cart/add"]'))sync(form);
  },true);
})();
